import { render, staticRenderFns } from "./GalleryImage.vue?vue&type=template&id=90b73ff6"
import script from "./GalleryImage.vue?vue&type=script&lang=js"
export * from "./GalleryImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports